export default "__VITE_ASSET__5nDVPPP0__"